import { Injectable, Provider } from '@angular/core';
import { QuantityUnitDto } from '../../INTEGRA_Shop_Client';
import { ENVIRONMENT } from '../../../environment/environment';
import { EDefaultSalesUnit } from '../../../enum/price/default-price.enum';
import { ISalesUnitService, ISalesUnitServiceToken } from './salesunit-service.interface';

@Injectable({
  providedIn: 'root'
})
export class SalesUnitService implements ISalesUnitService {

  public defaultSalesUnitGet(salesUnitList: QuantityUnitDto[] | undefined): QuantityUnitDto | undefined {
    if (salesUnitList == undefined || salesUnitList.length <= 0) { return undefined; }

    let defaultSalesUnit = ENVIRONMENT.price.defaultSalesUnit;

    let salesUnit = undefined;
    switch (defaultSalesUnit) {
      case EDefaultSalesUnit.Default:
        salesUnit = salesUnitList?.find(o => o.isDefault == true);
        if (salesUnit == undefined) {
          salesUnit = salesUnitList?.find(o => o.isSmallest == true);
        }
        break;
      case EDefaultSalesUnit.Smallest:
        salesUnit = salesUnitList?.find(o => o.isSmallest == true);
        if (salesUnit == undefined) {
          salesUnit = salesUnitList?.find(o => o.isDefault == true);
        }
        break;

      default:
        break;
    }

    if (salesUnit == undefined) {
      salesUnit = salesUnitList?.[0];
    }

    return salesUnit;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SalesUnitServiceProvider: Provider[] = [
  { provide: ISalesUnitServiceToken, useExisting: SalesUnitService }
];
